import React from "react";

import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import { Card } from "Theme/Card";

const Layout = ({ children }) => (
  <Div className="fill-viewport-height">
    <Grid componentClass={Card} mt={5}>
      {children}
    </Grid>
  </Div>
);

export default Layout;
